import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ["input"]
  static values = {
    disabled: { type: Boolean, default: true }
  }
  
  disabledValueChanged() {
    this.inputTargets.forEach((element) => {
      if ( element.classList.contains("selectpicker") ) {
        $(element).prop('disabled', this.disabledValue);
        $(element).selectpicker('refresh');
      } else {
        element.disabled = this.disabledValue
      }
    });
  }

  switchState(event){
    this.disabledValue = !this.disabledValue
  }
}